<template>
  <el-container>
    <!-- <leftAside /> -->
    <!-- <el-header><headTop /></el-header> -->
    <el-main><router-view /></el-main>
  </el-container>
</template>

<script>
import headTop from "../components/headTop";
import leftAside from "../components/leftAside";
export default {
  data() {
    return {};
  },
  components: { headTop, leftAside },
  methods: {},
};
</script>
<style lang="less" scoped>
@import "../style/common";
@import "../style/mixin";
.el-container {
  height: 100%;
  padding: 0px;
}
.el-aside {
  height: 100%;
}
.el-header {
  background-color: #111217;
  padding: 0;
}
.el-main {
  // padding: '0px';
  padding: 0;
  background-color: #111217;
}
.container {
  // position: absolute;
  display: flex;
  // justify-content: center;
  align-items: center;
  background-color: #111217;
}
</style>
